export default __webpack_public_path__ + "static/media/djbravo.6b00e17e.png";